export const Z_INDEX = {
	MINI_CART_DRAWER: 9001,
	AUTH_FLOW_DRAWER: 9002,
	AUTH_FLOW_ALERT: 9003,
};
